import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import { FC } from "react"
import "./EmailSendingConfirmation.less"

const { Title, Paragraph } = WebsiteTypography

const EmailSendingConfirmation: FC = () => {
  const { setIsModalDarkOpen } = useModalDarkContext()
  const handleClose = () => {
    setIsModalDarkOpen(false)
  }

  return (
    <Row
      justify={"center"}
      className={"email-sending-confirmation-wrapper"}
      style={{ paddingTop: 24, paddingBottom: 24 }}
    >
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Title level={3} centered className={"section-title"} color={"green"} style={{ paddingBottom: 24 }}>
          <span className={"w300"}>{"Email Confirmation Resent "}</span>
          <span className={"bold"}>{"Successfully"}</span>
        </Title>

        <Row justify={"center"}>
          <div className={"hex-wrapper"}>
            <SvgIcon type={"envelope-with-lock"} />
          </div>
        </Row>

        <Row justify={"center"}>
          <Col span={18}>
            <Paragraph
              centered
              size={"md"}
              style={{ paddingTop: 24, paddingBottom: 24 }}
              color={"white"}
              weight={"w300"}
            >
              {"A confirmation email has been resent to your inbox. Kindly check your spam folder if it’s not visible."}
            </Paragraph>
          </Col>
        </Row>
      </Col>

      <Row justify={"center"} className={"divider-with-hex"} style={{ margin: "0 0 24px 0" }}>
        <div className={"hex-small"} />
      </Row>

      <Col span={24} style={{ paddingTop: 32 }}>
        <Row justify={"center"}>
          <Button btnType={"primary"} text={"Close"} onClick={handleClose} />
        </Row>
      </Col>
    </Row>
  )
}

export default EmailSendingConfirmation
